const LoadingSpinner = ({ message = 'Loading' }) => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    padding: '3rem 0',
    color: 'var(--fg-muted)',
    fontSize: '0.875rem'
  }}>
    {message}
    <span className="term-cursor" aria-hidden="true"></span>
  </div>
);

export default LoadingSpinner;
